import React from "react";
import useReveal from "../../hooks/useReveal";
import useSEO from "../../seo/useSEO";
import Hero from "./Hero";
import Marquee from "./Marquee";
import Services from "./Services";
import Stats from "./Stats";
import FeaturedWork from "./FeaturedWork";
import Stack from "./Stack";
import Testimonials from "./Testimonials";
import CTA from "./CTA";

export default function Home() {
  useReveal();
  useSEO({
    title:
      "Oguzhan Ozcelik — Full-Stack Developer & Shopify Expert | Portfolio",
    description:
      "Portfolio of Oguzhan Ozcelik (Ozzy) — full-stack developer & Shopify expert based in New York. React, Node.js, Laravel and high-performance e-commerce.",
    path: "/",
    type: "website",
  });

  return (
    <main>
      <Hero />
      <Marquee />
      <Services />
      <Stats />
      <FeaturedWork />
      <Stack />
      <Marquee reverse />
      <Testimonials />
      <CTA />
    </main>
  );
}
